import { startCase, toLower } from 'lodash';

/**
 * Capitalizes the first letter of each word and lowercases the rest.
 * Ex: "mERRillviLLe" -> "Merrillville"
 *     "hello world" -> "Hello World"
 */
export const capitalizeWords = (input: string = ''): string =>
  startCase(toLower(input));
